function SummaryPreviewPanel() {};


SummaryPreviewPanel.events = {
    is_init_events_called: 0,

    init: function() {
        var _this = this;
        if (SummaryPreviewPanel.events.is_init_events_called === 0) {
            $("#right-pane-column").on('click', '.richardson-footer .uniform-summary-preview', function(event) {
                // Show confirmation
                if (_.size(ub.current_material.settings.roster) > 0 && _.size(ub.current_material.settings.size_breakdown) > 0) {
                    _this.loadViewSummary();
                } else {
                    UIkit.modal("#roster-confirmation").show();
                }
            });

            $("#richardson-saving-option").on("click", ".switch-reg-login", function() {
                var type = $(this).data("type");

                if (type === "login") {
                    $("#richardson-saving-option .login-container").removeClass("uk-hidden");
                    $("#richardson-saving-option .registration-container").addClass("uk-hidden");
                } else {
                    $("#richardson-saving-option .registration-container").removeClass("uk-hidden");
                    $("#richardson-saving-option .login-container").addClass("uk-hidden");
                }
            });

            $("#richardson-saving-option").on("click", ".summary-content .save-my-design", _this.onSaveToMyDesign);

            $("#richardson-saving-option").on("submit", "form#send-email", _this.onSubmitFormSendEmail);
            $("#richardson-saving-option").on("submit", "form#login-customer", _this.onSubmitFormLoginCustomer);
            $("#richardson-saving-option").on("submit", "form#registration-form", _this.onSubmitFormRegistration);

            $("#richardson-saving-option").on("click", ".cart-container .add-to-cart", _this.addToCart);
            $("#richardson-saving-option").on("click", ".cart-container .go-to-cart", _this.goToCart);
            $("#richardson-saving-option").on("click", ".cart-container .back-to-designer", _this.backToDesigner);
            // $("#richardson-saving-option").on("click", ".save-design-container .mysaved-design", _this.onClickToMySavedDesign);

            $("#roster-confirmation").on('click', '.confirmation-answer', function() {
                var answer = $(this).data('answer');
                UIkit.modal("#roster-confirmation").hide();
                if (answer.toLowerCase() === "yes") {
                    RosterPanel.events.init();
                    RosterPanel.events.onShowRoster();
                } else {
                    _this.loadViewSummary();
                }
            });

            SummaryPreviewPanel.events.is_init_events_called = 1
        }
    },

    loadViewSummary: function() {
        var _this = this;
        $("#richardson-saving-option form#save-design-form").trigger("reset");
        if (_this.isUniformChange() || ub.data.rosterIsChange) {
            // Hide Main Content Container
            $("#richardson-saving-option .uniform-thumbnail-container").addClass("uk-hidden");
            // Show loading screen
            SummaryPreviewPanel.events.showLoader();

            // Set All to undefined and false
            ub.current_material.settings.savedDesignID = undefined;
            ub.current_material.settings.design_number_magento = undefined;
            ub.data.addedToCart = false;
            ub.data.isSavedDesign = false;

            // Empty PDF container 
            $("#richardson-saving-option .pdf-container").html("");

            // Prepare Thumbnails and other settings
            _this.prepareThumbnails();
        } else {
            $("#richardson-saving-option .uniform-thumbnail-container").removeClass("uk-hidden");
            $('#richardson-saving-option .save-design-loading').fadeOut();
        }

        var template = '';
        if (ub.funcs.isDealer()) {
            template = document.getElementById("m-summary-dealer").innerHTML;
        } else if (ub.funcs.isPlayer()) {
            template = document.getElementById("m-summary-player").innerHTML;
        } else {
            template = document.getElementById("m-summary-guest").innerHTML;
        }

        var renderTemplate = Mustache.render(template, {
            magento_url: ub.config.magentoURL
        });

        $("#richardson-saving-option .summary-content").html("");
        $("#richardson-saving-option .summary-content").html(renderTemplate);
        $("#richardson-saving-option .design-id").val(ub.config.material_id);

        if (ub.data.addedToCart) {
            $("#richardson-saving-option button.add-to-cart").addClass("uk-disabled");
        }

        if (ub.data.isSavedDesign) {
            $(".save-design-container .goto-mysaved-design").removeClass("uk-hidden");
            $(".save-design-container .view-container").html("");
            $(".save-design-container .view-container")
                .html('<a target="_blank" class="uk-button uk-width-1-1 fc-white bgc-darkGray abrade-ultra-italic hov-red" href="'+ ub.config.magentoURL + "/uniform-saved-design/"+ ub.current_material.settings.savedDesignID +'"> View '+ ub.current_material.settings.design_number_magento +'</a>');
        }

        if (_.size(ub.current_material.settings.roster) > 0 && _.size(ub.current_material.settings.size_breakdown) > 0) {
            $("#richardson-saving-option .cart-container .add-to-cart").removeClass("uk-disabled");
        } else {
            var template = document.getElementById("m-alert-message").innerHTML;
            var render = Mustache.render(template, {message: "Your roster is empty. Add item in your roster before adding to cart.", type: "primary"});

            $("#richardson-saving-option .cart-container .message-container").html(""); 
            $("#richardson-saving-option .cart-container .message-container").html(render);
            $("#richardson-saving-option .cart-container .add-to-cart").addClass("uk-disabled");
        }

        UIkit.modal("#richardson-saving-option").show();
    },

    onClickToMySavedDesign: function() {
        var url = ub.config.magentoURL + "/saveandshare/index/mydesigns";
        window.parent.location.replace(url);
    },

    onSubmitFormSendEmail: function(event) {
        event.preventDefault();
        var mainFormElement = $("#richardson-saving-option form#send-email");
        var data = {
            "dealer_email": $("input.receiver-email", mainFormElement).val(),
            "your_email": $("input.sender-email", mainFormElement).val(),
            "your_name": $("input.sender-name", mainFormElement).val(),
            "message": $("textarea.sender-message", mainFormElement).val(),
            "pdf_url": ub.current_material.settings.uniformPreviewPdf,
            "pdf_name": "Richardson Customizer",
        };

        SummaryPreviewPanel.events.getSavedDesignID(data, "email");
    },

    onSubmitFormLoginCustomer: function(event) {
        event.preventDefault();
        var mainFormElement = $("#richardson-saving-option form#login-customer");

        SummaryPreviewPanel.events.showLoader();

        var data = {
            "email": $("input.email", mainFormElement).val(),
            "password": $("input.password", mainFormElement).val(),
        }

        if (data.email.length === 0) {
            var render = Mustache.render(tmpl, {message: "Email is required"});
            $("form#login-customer input[name='email']").addClass('uk-form-danger');
            $("form#login-customer input[name='email']").parent().parent().append(render);
        }

        if (data.password.length === 0) {
            var render = Mustache.render(tmpl, {message: "Password is required"});
            $("form#login-customer input[name='password']").addClass('uk-form-danger');
            $("form#login-customer input[name='password']").parent().parent().append(render);
        }


        RichardsonLogin.events.postUserLogin(data.email, data.password, "finish");
    },

    onSubmitFormRegistration: function(event) {
        event.preventDefault();

        var mainFormElement = $("#richardson-saving-option form#registration-form");

        var password = $("input.password", mainFormElement).val();
        var confirm_password = $("input.confirm-password", mainFormElement).val();

        if (password !== confirm_password) {
            var render = SummaryPreviewPanel.events.showAlertMessage("Password not match", "danger");

            $(".registration-container .message-container").html("");
            $(".registration-container .message-container").html(render);

            $("form#registration-form input.confirm-password").addClass('uk-form-danger');
            return;
        }

        var data = {
            "name": $("input.name", mainFormElement).val(),
            "email": $("input.email", mainFormElement).val(),
            "password": password,
        }

        SummaryPreviewPanel.events.showLoader();
        SummaryPreviewPanel.events.postRegisterUserMagento(data);
    },

    addToCart: function() {
        var ajax_type;
        if (ub.config.addCartJson !== "1" || ub.config.addCartJson === "") {
            ajax_type = ""
        } else {
            ajax_type = "json"
        }

        var data = {
            "customer_id": ub.user.id,
            "model_id": ub.current_material.material.style_number, 
            "sizes": JSON.stringify(ub.current_material.settings.size_breakdown),
            "pdf_url": ub.current_material.settings.uniformPreviewPdf,
            "ajax_type": ajax_type
        }

        if (typeof ub.current_material.settings.size_breakdown !== "undefined") {
            SummaryPreviewPanel.events.getSavedDesignID(data, "cart");
        }
    },

    postAddToCart: function(data) {
        SummaryPreviewPanel.events.updateSavedDesignBuilderCustomization(function() {
            if (ub.config.addCartJson !== "1" || ub.config.addCartJson === "") {
                if (typeof $.ajaxSettings.headers !== "undefined") {
                    delete $.ajaxSettings.headers["X-CSRF-TOKEN"];
                }

                $.ajax({
                    url: ub.config.magentoURL + "/saveandshare/index/uniformProductConfiguration",
                    data: data,
                    type: "POST",
                    crossDomain: true,
                    dataType: 'jsonp',
                    success: function (response) {
                        var render;
                        if (response.status) {
                            render = SummaryPreviewPanel.events.showAlertMessage("Your design added successfully", "success");
                            $(".cart-container .add-to-cart").addClass("uk-disabled");
                            var obj = {
                                "action": "update_cart",
                                "count": response.cartCount
                            };
                            parent.postMessage(obj, ub.config.magentoURL);
                            ub.data.addedToCart = true;
                        } else {
                            render = SummaryPreviewPanel.events.showAlertMessage(response.message, "danger");
                        }

                        $(".cart-container .message-container").html("");
                        $(".cart-container .message-container").html(render);
                        SummaryPreviewPanel.events.hideLoader();
                        SummaryPreviewPanel.events.hideMessage();
                    },

                    error: function(err) {
                        SummaryPreviewPanel.events.hideLoader();
                    }
                });
            } else {
                var postMessageData = {
                    action: "add_to_cart",
                    data: data
                };

                parent.postMessage(postMessageData, ub.config.magentoURL);
            }
        });
    },

    goToCart: function() {
        var url = ub.config.magentoURL + "/checkout/cart";
        window.parent.location.replace(url);
    },

    backToDesigner: function() {
        UIkit.modal("#richardson-saving-option").hide();
    },

    // Generate PDF
    pdfBuilder: function(callback) {
        // Setup Fabrics
        FabricPanel.prepareFabricPayload()

        var data = {
            "selectedSource":"Richardson Customizer",
            "selectedTemplate":"Richardson",
            "searchKey": Math.random().toString(36).substring(2, 15) + "-RCY-" + new Date().getFullYear(),
            "thumbnails": ub.current_material.settings.thumbnails,
            "category": ub.config.sport,
            "fullName": ub.user ? ub.user.fullname : "Guest User",
            "client": ub.user ? ub.user.fullname : "Guest User",
            "orderId": ub.current_material.settings.design_number_magento,
            "foid":"",
            "description": ub.config.description,
            "cutPdf": ub.current_material.settings.cut_pdf,
            "stylesPdf": ub.current_material.settings.styles_pdf,
            "roster": ub.current_material.settings.roster,
            "pipings": ub.current_material.settings.pipings,
            "createdDate": moment().format('LL'),
            "notes":"",
            "sizeBreakdown": ub.current_material.settings.size_breakdown,
            "applications": ub.current_material.settings.applications,
            "sizingTable":"",
            "upper": ub.config.type === "upper" ? ub.current_material.settings.upper : "",
            "lower": ub.config.type === "lower" ? ub.current_material.settings.lower : "",
            "hiddenBody": ub.current_material.settings.hiddenBody,
            "randomFeeds": ub.funcs.isSocks() ? ub.current_material.settings.randomFeeds: "",
            "legacyPDF":"",
            "applicationType": ub.config.uniform_application_type,
            "brandLogo": ""
        }

        // Setup Brand Logo 
        LogoPanel.utilities.generateRLogoThumbnail(function(logo) {
            // Assign BrandLogo
            data.brandLogo = logo;
            var url = "https://pdf-generator.prolook.com/api/upload";
            $.ajax({
                url: url,
                type: "POST",
                data: JSON.stringify(data),
                dataType: "json",
                crossDomain: true,
                contentType: 'application/json',
                headers: {
                    "accessToken": null
                },
                success: function (response) {
                    if (response.success) {
                        $('#richardson-saving-option .save-design-loading').fadeOut();
                        $("#richardson-saving-option .design-preview").removeClass("uk-hidden");
                        $("#richardson-saving-option .uniform-thumbnail-container").removeClass("uk-hidden");
                        // PDF Order Form
                        ub.current_material.settings.uniformPreviewPdf = response.pdfUrl;
                        ub.current_material.settings.pdfOrderForm = response.pdfUrl;
                        ub.data.rosterIsChange = false;
                    } else {
                        UIkit.modal("#richardson-saving-option").hide();

                        var message = 'Something went wrong while generating the PDF. Please try again later. Send your feedback if the problem persists. We appreciate your comments. Our team will be working on it as soon as possible.';
                        ub.funcs.showNotification(message, "danger", 3000);
                    }

                    // ORDER EDITOR CODE
                    if (_.isFunction(callback)) {
                        callback(response);
                    }
                },

                error: function(error) {
                    UIkit.modal("#richardson-saving-option").hide();

                    var message = 'Something went wrong while generating the PDF. Please try again later. Send your feedback if the problem persists. We appreciate your comments. Our team will be working on it as soon as possible.';
                    ub.funcs.showNotification(message, "danger", 3000);
                }
            });
        })

        
    },

    prepareThumbnails: function() {
        ub.front_view.visible = true;
        ub.back_view.visible = true;
        ub.left_view.visible = true;
        ub.right_view.visible = true;

        ub.funcs.deactivateMoveTool();

        ub.current_material.settings.thumbnails = {
            front_view: "",
            back_view: "",
            left_view: "",
            right_view: "",
        }

        if (typeof ub.data.previousThumbnails === "undefined") {
            ub.data.previousThumbnails = {
                front_view: "",
                back_view: "",
                left_view: "",
                right_view: "",
            }
        }

        this.uploadThumbnailUniformPreview("front_view")
        this.uploadThumbnailUniformPreview("back_view")
        this.uploadThumbnailUniformPreview("left_view")
        this.uploadThumbnailUniformPreview("right_view")
    },

    // Upload uniform images to be used for the PDF Viewer
    uploadThumbnailUniformPreview: function (view) {
        var _dataUrl = ub.getThumbnailImage(view);
        ub.data.previousThumbnails[view] = _dataUrl;

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            data: JSON.stringify({ dataUrl: _dataUrl }),
            url: ub.config.host + "/saveLogo",
            dataType: "json",
            type: "POST",
            crossDomain: true,
            contentType: 'application/json',
            headers: {"accessToken": null},
            success: function (response){
                if(response.success) {
                    ub.current_material.settings.thumbnails[view] = response.filename;
                    $("#richardson-saving-option .uniform-thumbnail-container ." + view + " img").attr('src', response.filename);
                    if (ub.funcs.thumbnailsUploaded()) {
                        SummaryPreviewPanel.events.generatePDFandDesignNumber();
                    }
                } else {
                    ub.utilities.info('Error generating thumbnail for ' + view);
                    ub.utilities.info(response.message);
                }
            },

            error: function(error) {
                ub.utilities.info(error);
            }
        });
    },

    // Check if the uniform has been modified
    isUniformChange: function() {
        if (typeof ub.data.previousThumbnails === "undefined") {
            return true;
        } else {
            var isChangeFront = ub.data.previousThumbnails["front_view"] !== ub.getThumbnailImage("front_view");
            var isChangeBack = ub.data.previousThumbnails["back_view"] !== ub.getThumbnailImage("back_view");
            var isChangeLeft = ub.data.previousThumbnails["left_view"] !== ub.getThumbnailImage("left_view");
            var isChangeRight = ub.data.previousThumbnails["right_view"] !== ub.getThumbnailImage("right_view");
            var isChangeThumbnails = false;

            var isChangeThumbnails = isChangeFront || isChangeBack || isChangeLeft || isChangeRight;

            return isChangeThumbnails;
        }
    },

    onSaveToMyDesign: function() {
        ub.utilities.info("Sending save design")
        var _userID = ub.user.id;
        var _designName = $('#richardson-saving-option #save-design-form input.design-name').val();
        var _materialID = ub.current_material.material.id;
        var _builderCustomizations = ub.current_material.settings;
        var _sport = ub.current_material.material.uniform_category;
        var _frontView = ub.current_material.settings.thumbnails.front_view;
        var _backView = ub.current_material.settings.thumbnails.back_view;
        var _leftView = ub.current_material.settings.thumbnails.left_view;
        var _rightView = ub.current_material.settings.thumbnails.right_view;
        var _notes = $('#richardson-saving-option #save-design-form .design-notes').val();

        SummaryPreviewPanel.events.prepareOrderData();

        var _data = {
            user_id: "2974",
            name: _designName,
            material_id: _materialID,
            material_name: ub.current_material.material.name,
            user: ub.user.fullname,
            builder_customizations: _builderCustomizations,
            sport: _sport,
            front_thumbnail: _frontView,
            back_thumbnail: _backView,
            left_thumbnail: _leftView,
            right_thumbnail: _rightView,
            notes: _notes
        };

        if (ub.data.updateSaveDesignFromCustomArtworkRequest) {
            _data.id = ub.config.savedDesignInfo.savedDesignID;
            _data.builder_customizations = _data.builder_customizations;

            delete _data.user;
            delete _data.material_name;
        }

        $("#richardson-saving-option .uniform-thumbnail-container").addClass("uk-hidden");
        $('#richardson-saving-option .save-design-loading').fadeIn();
        $("#richardson-saving-option .loading-message").html("");
        $("#richardson-saving-option .loading-message").html("Saving design......");
        

        if (typeof ub.current_material.settings.savedDesignID === "undefined") {
            SummaryPreviewPanel.events.postSaveDesign(_data);
        } else {
            var data = {
                "image": ub.current_material.settings.thumbnails.front_view,
                "customerID": ub.user.id,
                "design_id": ub.current_material.settings.savedDesignID,
                "url": ub.config.magentoURL + "/uniform-saved-design/" + ub.current_material.settings.savedDesignID,
                "pdf_url": ub.current_material.settings.uniformPreviewPdf
            };

            SummaryPreviewPanel.events.postSaveDesignMagento(data);
        }
    },

    postSaveDesign: function(data, callback) {
        var _url = window.ub.config.api_host + '/api/saved_design'

        if (ub.data.updateSaveDesignFromCustomArtworkRequest) {
            _url = window.ub.config.api_host + '/api/saved_design/update';
        }

        // Skip notification when coming from local
        if (ub.config.app_env === 'local') { data.test_data = '1'; }
        
        if (typeof $.ajaxSettings.headers !== "undefined") {
            delete $.ajaxSettings.headers["X-CSRF-TOKEN"];
        }

        $.ajax({
            url: _url,
            dataType: "json",
            type: "POST",
            data: JSON.stringify(data),
            crossDomain: true,
            contentType: 'application/json',
            headers: {"accessToken": null},
        
            success: function (response){
                if (response.success) {
                    var data = {
                        "image": ub.current_material.settings.thumbnails.front_view,
                        "customerID": ub.user.id,
                        "design_id": response.sd_id,
                        "url": ub.config.magentoURL + "/uniform-saved-design/" + response.sd_id,
                        "pdf_url": ub.current_material.settings.uniformPreviewPdf
                    };

                    if (typeof callback !== "undefined") {
                        callback(response);
                    } else {
                        SummaryPreviewPanel.events.postSaveDesignMagento(data);
                    }
                
                } else {
                    ub.utilities.info('Error Saving Design.');
                    UIkit.modal("#richardson-saving-option").hide();
                }
            }
        });
    },

    postSaveDesignMagento: function(data) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            url: ub.config.host + '/richardson/save-design',
            data: data,
            type: "POST",
            dataType: 'json',
            success: function (response) {
                var render;
                if (response.status) {
                    ub.data.isSavedDesign = true;
                    $(".save-design-container .goto-mysaved-design").removeClass("uk-hidden");
                    $(".save-design-container .view-container").html("");
                    $(".save-design-container .view-container").html('<a target="_blank" class="uk-button uk-width-1-1 fc-white bgc-darkGray abrade-ultra-italic hov-red" href="'+ ub.config.magentoURL + "/uniform-saved-design/"+ ub.current_material.settings.savedDesignID +'"> View '+ data.design_id +'</a>');
                    render = SummaryPreviewPanel.events.showAlertMessage("Your design saved sucessfully", "success");

                    $("#richardson-saving-option .pdf-container").html("");
                    $("#richardson-saving-option .pdf-container").html('<a class="uk-button uk-button-default" href="'+ ub.current_material.settings.pdfOrderForm +'" target="_blank"><span uk-icon="cloud-download"></span> Download PDF</a>');
                } else {
                    render = SummaryPreviewPanel.events.showAlertMessage(response.message, "danger");
                }

                $(".save-design-container .message-container").html("");
                $(".save-design-container .message-container").html(render);

                $("#richardson-saving-option .uniform-thumbnail-container").removeClass("uk-hidden");
                $('#richardson-saving-option .save-design-loading').fadeOut();
                SummaryPreviewPanel.events.hideMessage();
            },

            error: function(err) {
                var render = SummaryPreviewPanel.events.showAlertMessage("Something went wrong! Please try again." , "danger");
                $(".save-design-container .message-container").html("");
                $(".save-design-container .message-container").html(render);

                $("#richardson-saving-option .uniform-thumbnail-container").removeClass("uk-hidden");
                $('#richardson-saving-option .save-design-loading').fadeOut();

                SummaryPreviewPanel.events.hideMessage();
            }
        });
    },

    postRegisterUserMagento: function(data) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            url: ub.config.host + '/richardson/register',
            data: data,
            type: "POST",
            crossDomain: true,
            dataType: 'json',
            success: function (response) {
                if (response.status) {
                    // Save USer
                    window.ub.user = {
                        id: parseInt(response.id),
                        fullname: response.fullname,
                        firstName: response.firstName,
                        lastName: response.lastName,
                        email: response.email,
                        type: response.type
                    };
                    
                    ub.id = response.id;
                    ub.funcs.afterLogin();

                    SummaryPreviewPanel.events.hideLoader();
                    SummaryPreviewPanel.events.showSavedDesign();

                    var render = SummaryPreviewPanel.events.showAlertMessage(response.message, "success");

                    $(".save-design-container .message-container").html("");
                    $(".save-design-container .message-container").html(render);
                } else {
                    SummaryPreviewPanel.events.hideLoader();
                    var render = SummaryPreviewPanel.events.showAlertMessage(response.message, "danger");

                    $(".registration-container .message-container").html("");
                    $(".registration-container .message-container").html(render);
                }

                SummaryPreviewPanel.events.hideMessage();
            },

            error: function(err) {
                SummaryPreviewPanel.events.hideLoader();
                var template = document.getElementById("m-alert-message").innerHTML;
                var render = Mustache.render(template, {message: "Something went wrong."});

                $(".registration-container .message-container").html("");
                $(".registration-container .message-container").html(render);
                ub.utilities.info(err)
            }
        });
    },

    postSendEmail: function(data) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            url: ub.config.host + "/richardson/send-email",
            data: data,
            type: "POST",
            dataType: 'json',
            success: function (response) {
                var render;
                if (response.status) {
                    render = SummaryPreviewPanel.events.showAlertMessage(response.message, "success");
                } else {
                    render = SummaryPreviewPanel.events.showAlertMessage(response.message, "danger");
                }

                $(".send-design-container .message-container").html("");
                $(".send-design-container .message-container").html(render);
                SummaryPreviewPanel.events.hideLoader();
                SummaryPreviewPanel.events.hideMessage();
            },

            error: function(err) {
                var render = SummaryPreviewPanel.events.showAlertMessage("Something went wrong. Please try again.", "danger");
                $(".send-design-container .message-container").html("");
                $(".send-design-container .message-container").html(render);
                SummaryPreviewPanel.events.hideLoader();
                SummaryPreviewPanel.events.hideMessage();
            }
        });
    },

    getSavedDesignID: function(data, type) {
        var _userID = ub.user.id;
        var _designName = "";
        var _materialID = ub.current_material.material.id;
        var _builderCustomizations = ub.current_material.settings;
        var _sport = ub.current_material.material.uniform_category;
        var _frontView = ub.current_material.settings.thumbnails.front_view;
        var _backView = ub.current_material.settings.thumbnails.back_view;
        var _leftView = ub.current_material.settings.thumbnails.left_view;
        var _rightView = ub.current_material.settings.thumbnails.right_view;
        var _notes = "";

        SummaryPreviewPanel.events.prepareOrderData();

        var _data = {
            user_id: "2974",
            name: _designName,
            material_id: _materialID,
            material_name: ub.current_material.material.name,
            user: "Quickstrike Test User Name",
            builder_customizations: _builderCustomizations,
            sport: _sport,
            front_thumbnail: _frontView,
            back_thumbnail: _backView,
            left_thumbnail: _leftView,
            right_thumbnail: _rightView,
            notes: _notes
        };

        if (ub.data.updateSaveDesignFromCustomArtworkRequest) {
            _data.id = ub.config.savedDesignInfo.savedDesignID;
            _data.builder_customizations = _data.builder_customizations;

            delete _data.user;
            delete _data.material_name;
        }

        if (typeof ub.current_material.settings.savedDesignID === "undefined") {
            SummaryPreviewPanel.events.showLoader();
            SummaryPreviewPanel.events.postSaveDesign(_data, function(response) {
                data["design_number"] = response.sd_id;
                data["design_url"] = ub.config.magentoURL + "/uniform-saved-design/" + response.sd_id;
                data["image_url"] = ub.current_material.settings.thumbnails.front_view;
                ub.current_material.settings.savedDesignID = response.sd_id;

                if (type === "cart") {
                    SummaryPreviewPanel.events.postAddToCart(data);
                } else if (type === "email") {
                    SummaryPreviewPanel.events.postSendEmail(data);
                } else {
                    ub.utilities.info("Please specify type");
                }
            });
        } else {
            var savedDesignID = ub.current_material.settings.savedDesignID;
            data["design_number"] = savedDesignID;
            data["design_url"] = ub.config.magentoURL + "/uniform-saved-design/" + savedDesignID;
            data["image_url"] = ub.current_material.settings.thumbnails.front_view;
            SummaryPreviewPanel.events.showLoader();

            if (type === "cart") {
                SummaryPreviewPanel.events.postAddToCart(data);
            } else if (type === "email") {
                SummaryPreviewPanel.events.postSendEmail(data);
            } else {
                ub.utilities.info("Please specify type");
            }
        }
    },

    showLoader: function() {
        $('#richardson-saving-option .save-design-loading').fadeIn();
        $("#richardson-saving-option .uniform-thumbnail-container").addClass("uk-hidden");
    },

    hideLoader: function() {
        $("#richardson-saving-option .uniform-thumbnail-container").removeClass("uk-hidden");
        $('#richardson-saving-option .save-design-loading').fadeOut();
    },

    showSavedDesign: function() {
        var template = document.getElementById("m-summary-saved-design").innerHTML;
        var render = Mustache.render(template, {
            magento_url: ub.config.magentoURL
        });

        $("#richardson-saving-option .save-design-container").html("");
        $("#richardson-saving-option .save-design-container").html(render);

        $("#richardson-saving-option .design-id").val(ub.config.material_id);
    },

    showAlertMessage: function(message, type) {
        var template = document.getElementById("m-alert-message").innerHTML;
        var render = Mustache.render(template, {message: message, type: type});

        return render;
    },

    hideMessage: function() {
        _.delay(function() {
            $("#richardson-saving-option .message-container").html("");
        }, 5000)
    },

    reIniateSavingOptionUI: function() {
        var template = '';
        if (ub.funcs.isDealer()) {
            template = document.getElementById("m-summary-dealer").innerHTML;
        } else if (ub.funcs.isPlayer()) {
            template = document.getElementById("m-summary-player").innerHTML;
        } else {
            template = document.getElementById("m-summary-guest").innerHTML;
        }

        var renderTemplate = Mustache.render(template, {
            magento_url: ub.config.magentoURL
        });
        
        $("#richardson-saving-option .summary-content").html("");
        $("#richardson-saving-option .summary-content").html(renderTemplate);
        $("#richardson-saving-option .design-id").val(ub.config.material_id);

        if (_.size(ub.current_material.settings.roster) > 0 && _.size(ub.current_material.settings.size_breakdown) > 0) {
            $("#richardson-saving-option .cart-container .add-to-cart").removeClass("uk-disabled");
        } else {
            var template = document.getElementById("m-alert-message").innerHTML;
            var render = Mustache.render(template, {message: "Your roster is empty. Add item in your roster before adding to cart.", type: "primary"});

            $("#richardson-saving-option .cart-container .message-container").html("");
            $("#richardson-saving-option .cart-container .message-container").html(render);
            $("#richardson-saving-option .cart-container .add-to-cart").addClass("uk-disabled");
        }
    },

    prepareOrderData: function() {
        ub.current_material.settings.orderInfo = {
            brand: ub.current_material.material.brand,
            item_id: ub.current_material.material.item_id,
            type: ub.current_material.material.type,
            description: ub.current_material.material.name,
            design_sheet: ub.current_material.settings.pdfOrderForm,
            sku: ub.current_material.material.sku,
            material_id: ub.current_material.material.id,
            url: ub.config.host + window.document.location.pathname,
            price: ub.funcs.getPrice(ub.current_material.material),
            applicationType: ub.config.uniform_application_type.toTitleCase(),
            application_type: ub.config.uniform_application_type,
            additional_attachments: ub.data.orderAttachment,
            notes: ""
        }
    },

    generatePDFandDesignNumber: function() {
        var _userID = ub.user.id;
        var _designName = "";
        var _materialID = ub.current_material.material.id;
        var _builderCustomizations = ub.current_material.settings;
        var _sport = ub.current_material.material.uniform_category;
        var _frontView = ub.current_material.settings.thumbnails.front_view;
        var _backView = ub.current_material.settings.thumbnails.back_view;
        var _leftView = ub.current_material.settings.thumbnails.left_view;
        var _rightView = ub.current_material.settings.thumbnails.right_view;
        var _notes = "";

        SummaryPreviewPanel.events.prepareOrderData();

        var _data = {
            user_id: "2974",
            name: _designName,
            material_id: _materialID,
            material_name: ub.current_material.material.name,
            user: "Quickstrike Test User Name",
            builder_customizations: _builderCustomizations,
            sport: _sport,
            front_thumbnail: _frontView,
            back_thumbnail: _backView,
            left_thumbnail: _leftView,
            right_thumbnail: _rightView,
            notes: _notes
        };

        if (ub.data.updateSaveDesignFromCustomArtworkRequest) {
            _data.id = ub.config.savedDesignInfo.savedDesignID;
            _data.builder_customizations = _data.builder_customizations;

            delete _data.user;
            delete _data.material_name;
        }

        ub.utilities.info("Generate DESIGN NUMBER")
        SummaryPreviewPanel.events.postSaveDesign(_data, function(response) {
            ub.current_material.settings.savedDesignID = response.sd_id;
            ub.current_material.settings.design_number_magento = response.sd_id;
            SummaryPreviewPanel.events.pdfBuilder();
        });
    },

    postAddedToCart: function(result) {
        if (result.success) {
            ub.data.addedToCart = true;
            render = SummaryPreviewPanel.events.showAlertMessage("Your design added successfully", "success");
            $(".cart-container .add-to-cart").addClass("uk-disabled");
        } else {
            if (typeof result.message !== "undefined" && result.message.length > 0) {
                render = SummaryPreviewPanel.events.showAlertMessage(result.message, "danger");
            } else {
                render = SummaryPreviewPanel.events.showAlertMessage("Please add an item in your roster.", "danger");
            }
        }

        $(".cart-container .message-container").html("");
        $(".cart-container .message-container").html(render);

        SummaryPreviewPanel.events.hideLoader();
        SummaryPreviewPanel.events.hideMessage();
    },

    updateSavedDesignBuilderCustomization: function(callback) {
        var _url = ub.config.api_host + '/api/saved_design/update';

        // Skip notification when coming from local
        if (ub.config.app_env === 'local') { data.test_data = '1'; }
        
        if (typeof $.ajaxSettings.headers !== "undefined") {
            delete $.ajaxSettings.headers["X-CSRF-TOKEN"];
        }

        var _userID = ub.user.id;
        var _designName = "";
        var _materialID = ub.current_material.material.id;
        var _builderCustomizations = ub.current_material.settings;
        var _sport = ub.current_material.material.uniform_category;
        var _frontView = ub.current_material.settings.thumbnails.front_view;
        var _backView = ub.current_material.settings.thumbnails.back_view;
        var _leftView = ub.current_material.settings.thumbnails.left_view;
        var _rightView = ub.current_material.settings.thumbnails.right_view;
        var _notes = "";

        SummaryPreviewPanel.events.prepareOrderData();

        var _data = {
            id: ub.current_material.settings.savedDesignID,
            user_id: "2974",
            name: _designName,
            material_id: _materialID,
            builder_customizations: _builderCustomizations,
            sport: _sport,
            front_thumbnail: _frontView,
            back_thumbnail: _backView,
            left_thumbnail: _leftView,
            right_thumbnail: _rightView,
            notes: _notes
        };

        $.ajax({
            url: _url,
            dataType: "json",
            type: "POST",
            data: JSON.stringify(_data),
            crossDomain: true,
            contentType: 'application/json',
            headers: {"accessToken": null},
        
            success: function (response){
                if (response.success) {
                    if (_.isFunction(callback)) {
                        callback();
                    }
                } else {
                    var message = "Something went wrong while updating design! Please try again.";
                    ub.funcs.showNotification(message, "danger", 3000);
                    UIkit.modal("#richardson-saving-option").hide();
                }
            }
        });
    }
}